import { labelToManualTradingExchange } from '@/services/manualTradingExchange';

export type RealtimeSpreadDirection = 'long1_short2' | 'short1_long2';

export function resolveManualTradingLegs(
  ex1: string,
  ex2: string,
  realtimeDirection: RealtimeSpreadDirection,
) {
  const a = labelToManualTradingExchange(ex1);
  const b = labelToManualTradingExchange(ex2);
  if (!a || !b) return { ok: false as const, error: `无法识别的交易所标签：${ex1} / ${ex2}` };

  if (realtimeDirection === 'long1_short2') {
    return {
      ok: true as const,
      long_exchange: a,
      short_exchange: b,
    };
  }
  return {
    ok: true as const,
    long_exchange: b,
    short_exchange: a,
  };
}
